import { packingTracerAccionesRoles } from '../../acciones-roles/areas-de-trabajo/packing-tracer-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const PackingTrackerRoutes: SideBarButton = {
  data: {
    name: 'Escaneo',
    appendUrl: './scanner-v2',
    roles: [...packingTracerAccionesRoles.sideNavActions.scanner],
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        roles: [...packingTracerAccionesRoles.sharedActions.dataDisplay],
        name: 'Datos de Empaquetado',
        url: '/data-display',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Crear pallets',
        url: '/pallet',
        roles: [...packingTracerAccionesRoles.sharedActions.pallet],
        otherUrls: ['/pallet/:teamId', '/pallet/:teamId/:palletId'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Crear Camión',
        url: '/truck',
        roles: [...packingTracerAccionesRoles.sharedActions.truck],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Scanear Camión',
        url: '/truck/shipment',
        roles: [...packingTracerAccionesRoles.sharedActions.truck],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Desmantelacion pallets',
        url: '/destroy-pallet',
        roles: [...packingTracerAccionesRoles.sharedActions.destroyPallet],
        otherUrls: ['/destroy-pallet/:teamId'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Agregar SO a PB',
        url: '/clone',
        roles: [...packingTracerAccionesRoles.sharedActions.clone],
        otherUrls: ['/clone/:transactionNumber'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Recrear PB',
        url: '/rebuild',
        roles: [...packingTracerAccionesRoles.sharedActions.rebuild],
      },
      options: PreConfigButton3,
    },
  ],
};
